import React, {
  CSSProperties, useEffect, useRef, useState,
} from 'react';

interface Node {
  intersectionObserver: IntersectionObserver | null;
  exposed: boolean;
  onExposed?: Function;
}

function Exposure({
  children,
  className,
  style,
  onClick,
  onExposed,
  onlyOnce,
  ...restProps
}: {
  children: any;
  className?: string;
  style?: CSSProperties;
  onClick?: React.MouseEventHandler;
  onExposed?: Function;
  onlyOnce?: boolean;
} & Record<string, any>) {
  const ref = useRef<HTMLDivElement | null>(null);
  const node = useState(() => ({
    intersectionObserver: null,
    exposed: false,
    onExposed,
  } as Node))[0];

  useEffect(() => {
    function disconnectAndDeleteNode() {
      node.intersectionObserver?.disconnect();
    }

    // Safari under 12.1 does not support IntersectionObserver
    if (
      ref.current
      && typeof window !== 'undefined'
      && window.IntersectionObserver
    ) {
      node.intersectionObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0] && entries[0].intersectionRatio >= 0.5) {
            // console.log(nodeMap);
            if (node.exposed === false) {
              node.exposed = true;
              if (node.onExposed) {
                node.onExposed();
              }
              if (onlyOnce) {
                disconnectAndDeleteNode();
              }
            }
            else if (onlyOnce === false) {
              node.onExposed && node.onExposed();
            }
          }
        },
        {
          rootMargin: '0px',
          threshold: 0.51,
        },
      );
      node.intersectionObserver.observe(ref.current);
    }

    return () => {
      disconnectAndDeleteNode();
    };
  }, []);

  useEffect(() => {
    node.onExposed = onExposed;
  }, [onExposed]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return (
    <div className={className} style={style} ref={ref} onClick={onClick} {...restProps}>
      {children}
    </div>
  );
}

Exposure.defaultProps = {
  style: {},
  className: '',
  onClick: () => {},
  onExposed: () => {},
  onlyOnce: true,
};

export default Exposure;
